'use strict';

import Api  from 'services/api';
import Dispatcher  from 'dispatcher/TngAppDispatcher';
import appConstants from 'constants/appConstants';

const NewStarterActionCreators = {
    getNewStarters(nextPageLink) {
        Api.NEW_STARTERS.getNewStarters(nextPageLink);
    },
    getNewStartersCount() {
        Api.NEW_STARTERS.getNewStartersCount();
    },
    addNewStarter(data) {
        Api.NEW_STARTERS.addNewStarter(data);
    },
    addNonPayroll(data) {
        Api.NEW_STARTERS.addNonPayroll(data);
    },
    resendForm(id, emailAddress) {
        Api.NEW_STARTERS.resendForm(id, emailAddress);
    },
    deleteNewStarter(id) {
        Api.NEW_STARTERS.deleteNewStarter(id).then(function (response) {
            NewStarterActionCreators.getNewStarters();
        });
    },
    getNewStarter(newStarterWorkflowId, screenType, requestType) {
        Api.NEW_STARTERS.getNewStarter(newStarterWorkflowId, screenType, requestType);
    },
    updateNewStarter(newStarterWorkflowId, newStarter, screenType) {
        Api.NEW_STARTERS.updateNewStarter(newStarterWorkflowId, newStarter, screenType);
    },
    resetNewStarter() {
        Dispatcher.handleAction({
            actionType: appConstants.actions.NEW_STARTERS.RESET_NEW_STARTER,
        });
    },
    updateNewStarterStatus(id, action) {
        Api.NEW_STARTERS.updateNewStarterStatus(id, action).then(function (response) {
            NewStarterActionCreators.getNewStarterStatus(id);
        });
    },
    getNewStarterStatus(id) {
        Api.NEW_STARTERS.getNewStarterStatus(id);
    },
    getNewStarterCompletedPages(id) {
        Api.NEW_STARTERS.getNewStarterCompletedPages(id);
    },
    finaliseNewStarter: (id, model) => {
        Api.NEW_STARTERS.finaliseNewStarter(id, model);
    },
    getActionsCount: () => {
        Api.NEW_STARTERS.getActionsCount();
    },
};

export default NewStarterActionCreators;